import React, { useEffect, useState, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { io } from 'socket.io-client';
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://pochelo.online';
const socket = io(SOCKET_URL);

const UMBRAL_AMPERAJE = 50;
const COLOR_ALERTA_PUNTO = 'red';
const RADIO_PUNTO_NORMAL = 2;
const RADIO_PUNTO_ALERTA = 4;
const SONIDO_ALERTA_PATH = '/alerta.mp3';

const colorPorMaquina = {
    9:  '#e07b39ff',  // naranja
    10: '#c45cd4ff',  // violeta
    11: '#3bc4c4ff',  // cian
};

const LineChart3 = () => {
    const [chartData, setChartData] = useState({
        labels: Array.from({ length: 15 }, (_, i) => i + 1),
        datasets: [],
    });
    const [alertaActiva, setAlertaActiva] = useState({});
    const audioPlayer = useRef(null);

    useEffect(() => {
        audioPlayer.current = new Audio(SONIDO_ALERTA_PATH);
        audioPlayer.current.load();

        const dataMap = JSON.parse(localStorage.getItem('dataMap3')) || {};

        const updateChartData = () => {
            const datasets = [9, 10, 11].map((num) => {
                const key = `Machine${num}`;
                const datosMaquina = dataMap[key] || Array(15).fill(0);
                const colorLinea = colorPorMaquina[num];
                const pointBackgroundColors = datosMaquina.map(v =>
                    v > UMBRAL_AMPERAJE ? COLOR_ALERTA_PUNTO : colorLinea
                );
                const pointRadii = datosMaquina.map(v =>
                    v > UMBRAL_AMPERAJE ? RADIO_PUNTO_ALERTA : RADIO_PUNTO_NORMAL
                );
                return {
                    label: ` Machine${num}`,
                    data: datosMaquina,
                    fill: false,
                    borderColor: colorLinea,
                    tension: 0.6,
                    pointRadius: pointRadii,
                    pointHoverRadius: RADIO_PUNTO_ALERTA + 2,
                    borderWidth: window.innerWidth < 600 ? 0.8 : 1.5,
                    pointBackgroundColor: pointBackgroundColors,
                };
            });

            setChartData({
                labels: Array.from({ length: 15 }, (_, i) => i + 1),
                datasets,
            });
        };

        updateChartData();

        const handleData = (maquinaId, amperaje) => {
            if (typeof amperaje !== 'number') return;

            if (!dataMap[maquinaId]) dataMap[maquinaId] = Array(15).fill(0);
            dataMap[maquinaId].push(amperaje);
            if (dataMap[maquinaId].length > 15) dataMap[maquinaId].shift();

            if (amperaje > UMBRAL_AMPERAJE) {
                if (!alertaActiva[maquinaId]) {
                    if (audioPlayer.current) {
                        audioPlayer.current.play().catch(e => console.error(e));
                    }
                    setAlertaActiva(prev => ({ ...prev, [maquinaId]: true }));
                }
            } else {
                if (alertaActiva[maquinaId]) {
                    setAlertaActiva(prev => ({ ...prev, [maquinaId]: false }));
                }
            }

            localStorage.setItem('dataMap3', JSON.stringify(dataMap));
            updateChartData();
        };

        const h9  = (d) => handleData('Machine9',  d.amperaje);
        const h10 = (d) => handleData('Machine10', d.amperaje);
        const h11 = (d) => handleData('Machine11', d.amperaje);

        socket.on('mqttMachine9',  h9);
        socket.on('mqttMachine10', h10);
        socket.on('mqttMachine11', h11);

        return () => {
            socket.off('mqttMachine9',  h9);
            socket.off('mqttMachine10', h10);
            socket.off('mqttMachine11', h11);
            if (audioPlayer.current) {
                audioPlayer.current.pause();
                audioPlayer.current.src = '';
            }
        };
    }, [alertaActiva]);

    const options = {
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: { color: 'rgba(123, 104, 238, 0.3)' },
                ticks: { color: '#FFFFFF', padding: 10, font: { family: 'Roboto', size: 12, weight: '300' } }
            },
            y: {
                min: 0, max: 60,
                grid: { color: 'rgba(123, 104, 238, 0.3)' },
                ticks: { color: '#FFFFFF', padding: 10, font: { family: 'Roboto', size: 12, weight: '300' } }
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#FFFFFF',
                    font: { family: 'Roboto', size: 12, weight: '300' }
                }
            }
        }
    };

    return <Line data={chartData} options={options} />;
};

export default LineChart3;
